import Vue from 'vue'
import store from './store'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/addresses' },
    
    { path: '/addresses', component: require('./pages/Addresses.vue').default, meta: { auth: true } },
    { path: '/addresses/create', component: require('./pages/AddressesCreate.vue').default, meta: { auth: true } },
    { path: '/addresses/:id', component: require('./pages/Address.vue').default, meta: { auth: true } },
    { path: '/addresses/:id/edit', component: require('./pages/AddressesEdit.vue').default, meta: { auth: true } },
    
    { path: '/users', component: require('./pages/Users.vue').default, meta: { auth: true } },
    { path: '/users/create', component: require('./pages/UsersCreate.vue').default, meta: { auth: true } },
    { path: '/users/:id/edit', component: require('./pages/UsersEdit.vue').default, meta: { auth: true } },
    
    { 
      path: '/login', 
      component: require('./pages/Login.vue').default,
      beforeEnter (to, from, next) {
        if (store.state.user.role) {
          return next('/addresses')
        }

        next()
      }
    },

    {
      path: '/logout',
      beforeEnter (to, from, next) {
        store.commit('logout')
        next('/login')
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !store.state.user.role) {
    console.log('redirecting')
    return next('/login')
  }

  next()
})

export default router
